/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewUserAliases {
  BUTTON_CONFIRMATION = 'button-confirmation',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_GENDER = 'fetch-gender',
  FETCH_RECAPTCHA = 'fetch-recaptcha',
  FIELD_CELLPHONE = 'field-Cellphone',
  FIELD_CONFIRM_EMAIL = 'field-confirm-email',
  FIELD_CONFIRM_PW = 'field-confirm-pw',
  FIELD_CPF = 'field-cpf',
  FIELD_DATE_OF_BIRTH = 'field-Date-of-birth',
  FIELD_EMAIL = 'field-email',
  FIELD_GENDER = 'field-gender',
  FIELD_ID_NUMBER = 'field-id-Number',
  FIELD_NM_PERSON = 'field-nmPerson',
  FIELD_PW = 'field-pw',
  FIELD_RECAPTCHA = 'field-recaptcha',
  FIELD_TERM = 'field-term',
  FIELD_TOAST = 'field-toast',
  FORM_WIZARD_STEP_ACCOUNT_DATA = 'form-wizard-step-account-data',
  FORM_WIZARD_STEP_PERSONAL_INFORMATION = 'form-wizard-step-personal-information',
  HPMS_TERM_CHECKBOX = 'hpms-term-checkbox',
  IMAGE_SUCCESS = 'image-success',
  INPUT_CONFIRM_EMAIL = 'input-confirm-email',
  INPUT_CONFIRM_PW = 'input-confirm-pw',
  INPUT_CPF = 'input-cpf',
  INPUT_EMAIL = 'input-email',
  INPUT_ID_NUMBER = 'input-id-Number',
  INPUT_NM_USER = 'input-nmUser',
  INPUT_PW = 'input-pw',
  LAYOUT_NEW_USER = 'layout-new-user',
  LAYOUT_NEW_USER_SUCCESS = 'layout-new-user-success',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_2 = 'mapper-2',
  MAPPER_GENDER = 'mapper-gender',
  PANEL_CONFIRMATION = 'panel-confirmation',
  PANEL_FORM_NEW_USER = 'panel-form-new-user',
  PANEL_IMAGE = 'panel-image',
  PANEL_LOADER = 'panel-loader',
  PANEL_NEW_USER = 'panel-new-user',
  PANEL_REGISTER_NEW_USER = 'panel-register-new-user',
  PANEL_REGISTER_NEW_USER_SUCCESS = 'panel-register-new-user-success',
  PANEL_SUBTITLE = 'panel-subtitle',
  PHONE_NUMBER = 'phone-number',
  RECAPTCHA = 'recaptcha',
  TEXT_0 = 'text-0',
  TEXT_SUBTITLE = 'text-subtitle',
  TEXT_TITLE = 'text-title',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_0 = 'unboxed-autocomplete-0',
  WIZARD_NEW_USER = 'wizard-new-user',
  WIZARD_STEP_ACCOUNT_DATA = 'wizard-step-account-data',
  WIZARD_STEP_PERSONAL_INFORMATION = 'wizard-step-personal-information',
}
export { NewUserAliases };
